module.exports = __webpack_public_path__ + "img/opoczno_2-1.cf98a17e.png";